import { Button } from '@talentmesh/ui/components/button';
import UIStrings from '@/Utils/UIStrings';

function OidcActionButtons() {
    const getBaseUrl = (): string => {
        const { protocol, host } = window.location;
        return `${protocol}//${host}`;
    };

    const loginHandler = () => {
        window.location.href = getBaseUrl();
    };

    const signUpHandler = () => {
        window.location.href = `${getBaseUrl()}/register`;
    };

    return (
        <div className="flex flex-col gap-3 sm:flex-row sm:gap-4">
            <Button type="button" onClick={loginHandler}>
                {UIStrings.LogInToTalentmesh}
            </Button>
            <Button type="button" variant="outline" onClick={signUpHandler}>
                {UIStrings.GetFreeTrial}
            </Button>
        </div>
    );
}

export default OidcActionButtons;
